// extracted by mini-css-extract-plugin
module.exports = {"roomContainer":"room_type_roomContainer__f4iBb","ratesList":"room_type_ratesList__1Y3yV"};